import React from "react";
import { FINAL_INFO, colors } from "./OnboardingBuildAndSubmit";
import { FaCheck } from "react-icons/fa";
import BuildAndSubmitSlideOutButton from "./BuildAndSubmitSlideOut";

const FinalInfo = ({
  getIsCompleted
}) => {

  return (
    <div className="flex flex-row justify-between items-center p-2">
      <div className="w-full flex flex-row justify-start items-center">
        <button
          type="button"
          className={`p-2 cursor-not-allowed border-3 rounded`}
          style={{
            background: getIsCompleted({ id: FINAL_INFO })
              ? colors.dark
              : "#FFFFFF",
            borderColor: colors.dark,
          }}
        >
          <div
            className="rounded-lg"
            style={{
              borderColor: getIsCompleted({ id: FINAL_INFO })
                ? colors.dark
                : "#FFFFFF",
              backgroundColor: getIsCompleted({ id: FINAL_INFO })
                ? colors.dark
                : "#FFFFFF",
            }}
          >
            <FaCheck className={`text-white font-bold rounded-lg h-3 w-3`} />
          </div>
        </button>

        <span className={`line-clamp-2 font-bold ml-2 text-2xl`}>
          {FINAL_INFO}
        </span>
      </div>

      <BuildAndSubmitSlideOutButton
        type={FINAL_INFO}
        btnLabel={"INFO"}
        title="FINAL INFO"
      />
    </div>
  );
};

export default FinalInfo